import React, { KeyboardEventHandler, memo, MouseEventHandler } from 'react'
import classnames from 'classnames'
import { TAG_SIZE, TAG_STYLE, Tag } from 'transfix-ui/components/Tag'
import { TOptionValue, IFunctionalTagOption } from '../types'

interface IFunctionalTagOptionProps<T extends TOptionValue = string> {
  itemClassNames?: string
  option: IFunctionalTagOption<T>
  size: TAG_SIZE
  dataTest: string
  onOptionSelected: (option: IFunctionalTagOption<T>) => void
}

export const FunctionalTagOption = memo<IFunctionalTagOptionProps>(
  ({ dataTest, itemClassNames, onOptionSelected, option, size }) => {
    const { label, outlineOnly, style } = option
    const itemClasses = classnames('dpl-functional-tag-listbox-item', itemClassNames)

    const optionClickHandler: MouseEventHandler<HTMLButtonElement> = e => {
      e.stopPropagation()
      onOptionSelected(option)
    }

    const keyPressHandler: KeyboardEventHandler<HTMLButtonElement> = e => {
      e.stopPropagation()
      onOptionSelected(option)
    }

    return (
      <button
        className={itemClasses}
        onClick={optionClickHandler}
        onKeyDown={keyPressHandler}
        data-test={dataTest}
        aria-selected={false}
        role='option'
        disabled={option.disabled}
        tabIndex={-1}
        type='button'>
        <Tag
          size={size}
          label={label}
          tagStyle={option.disabled ? TAG_STYLE.disabled : style}
          outlineOnly={outlineOnly}
        />
      </button>
    )
  }
)

export default FunctionalTagOption
